import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Phone, Mail, ArrowLeft } from "lucide-react";

export default function NotaryConfirmation() {
  const nav = useNavigate();
  const { state } = useLocation();

  return (
    <div className="mx-auto max-w-xl space-y-6 py-12" data-testid="notary-confirmation-page">
      <div className="text-center">
        <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" />
        <h1 className="mt-4 font-display text-3xl font-bold text-slate-900">Request Received</h1>
        <p className="mt-3 text-slate-600">Thank you. Your Notary Service request has been received.</p>
        <p className="mt-3 text-slate-600">
          Our team will review your request and contact you to confirm availability, appointment details, and final pricing.
        </p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700" data-testid="notary-confirmation-fee">
        <p className="font-semibold text-slate-900">Mobile Service Fee</p>
        <p className="mt-1 leading-relaxed">
          A <strong>$35 mobile service fee</strong> applies to appointments within our standard service area.
          Final pricing is confirmed by our team after review.
        </p>
        {state?.area?.message && <p className="mt-2 text-slate-500">{state.area.message}</p>}
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="notary-confirmation-contact">
        <p className="font-display text-lg font-semibold text-slate-900">AR Process Service</p>
        <a href="tel:+19016952500" className="mt-2 flex items-center gap-2 text-slate-700 hover:text-indigo-700">
          <Phone className="h-4 w-4" /> (901) 695-2500
        </a>
        <a href="mailto:admin@artadmin.net" className="mt-1 flex items-center gap-2 text-slate-700 hover:text-indigo-700">
          <Mail className="h-4 w-4" /> admin@artadmin.net
        </a>
      </div>

      <div className="text-center">
        <Button data-testid="notary-confirmation-back" onClick={() => nav("/notary-services")} className="bg-indigo-600 text-white hover:bg-indigo-700">
          <ArrowLeft className="mr-1.5 h-4 w-4" /> Back to Notary Services
        </Button>
      </div>
    </div>
  );
}
